import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DateInsertFormat, DropdownPageSizeOptions, DropdownStatusList, DropdownTransactionStatus, DropdownTransactionType, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiGetTransactionList, ApiGetUserLocationByUserId } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import PaginationButton from "components/Input/PaginationButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, GetTransactionStatus, GetTransactionType, money } from "utils/helpers"
import DatePicker from "components/Input/DatePicker";
import moment from "moment";
import PrintButton from "components/Button/PrintButton";
import SalesReportPdf from "components/modal/components/SalesReportGenerator";
import SalesFormModal from "./SalesFormModal";

export default function Sales(){
    let navigate = useNavigate()

    const { data: transactionList, fetch: getTransactionList } = useFetch(ApiGetTransactionList)
    const { fetch: apiGetLocation } = useFetch(ApiGetUserLocationByUserId)

    const [locationOptions, setLocationOptions] = useState([])
    const [location, setLocation] = useState('1')
    const [firstLoad, setFirstLoad] = useState(true)

    const [vehicleModel, setVehicleModel] = useState(EmptyString)
    const [transactionType, setTransactionType] = useState(DropdownTransactionType[3].value)
    const [transactionStatus, setTransactionStatus] = useState(DropdownTransactionStatus[0].value)
    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [licensePlateNumber, setLicensePlateNumber] = useState(EmptyString)
    const [vehicleBrandOptions, setVehicleBrandOptions] = useState(JSON.parse(localStorage.getItem("VehicleBrand")))
    const [vehicleBrand, setVehicleBrand] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageSize, setPageSize] = useState(DropdownPageSizeOptions[0].value)
    const [salesFormModal, setSalesFormModal] = useState({ isOpen: false, transactionId: 0, locationId: 0, formType: FormTypeEdit, data: {} })
    const [isSummaryOpen, setIsSummaryOpen] = useState(false)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Event
    const salesFormModalClose = () => {
        setSalesFormModal({ isOpen: false, transactionId: 0 })
        fBindGrid(pageIndex, pageSize)
    }
    const transactionTypeChange = (e) => {
        setTransactionType(e.value)
    }
    const dateFromChange = (e) => {
        if(e === null){
            setDateFrom(new Date())
        }else{
            setDateFrom(e)
        }
    }
    const dateToChange = (e) => {
        if(e === null){
            setDateTo(new Date())
        }else{
            setDateTo(e)
        }
    }
    const pageSizeChange = (e) => {
        setPageSize(e.value)
    }
    
    // Button Event
    const addBtnClick = () => {
        navigate("/user/form?userId=&formType=" + FormTypeAdd)
    }
    const printBtnClick = () => {
        // Get New Data with no Page Size Limitation
        getTransactionListForPrint().then((sourceData) => {
            if (sourceData !== null) {
                console.log(sourceData)
                if (sourceData.data.listData.length > 0) {
                    let listData = sourceData.data.listData

                    const sampleData = listData
                    const data = [...sampleData]

                    const date1 = moment(dateFrom).format('DD MMMM YYYY')
                    const date2 = moment(dateTo).format('DD MMMM YYYY')
                    const locName = locationOptions.find(x => x.value === location).label

                    SalesReportPdf(data, date1, date2, location, transactionType, locName)
                } else {
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                            }
                        },
                        message: "No Data Available"
                    })
                }
            }
        })
    }
    const transactionDataClick = (id, locationId) => {
        setSalesFormModal({ isOpen: true, transactionId: id, locationId: locationId, formType: FormTypeView  })
    }

    // Function Api Call
    const getTransactionListForPrint = async() => {
        let res = await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(DateInsertFormat),
                dateTo: moment(dateTo).format(DateInsertFormat),
                locationId: location === EmptyString ? 0 : location,
                transactionType: parseInt(transactionType === EmptyString ? 0 : transactionType),
                licensePlateNumber,
                vehicleBrand: vehicleBrand === null || vehicleBrand === EmptyString ? 0 : (vehicleBrand.value === EmptyString || vehicleBrand.value === null ? 0 : parseInt(vehicleBrand.value)),
                employeeName: EmptyString,
                vehicleModel,
                status,
                transactionStatus,
                pageSize: 100000,
                pageIndex: 0
            }
        })
        return res
    }
    async function fGetTransactionList(i){
        let res
        
        await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(DateInsertFormat),
                dateTo: moment(dateTo).format(DateInsertFormat),
                locationId: location === EmptyString ? 0 : location,
                transactionType: parseInt(transactionType === EmptyString ? 0 : transactionType),
                licensePlateNumber,
                vehicleBrand: vehicleBrand === null || vehicleBrand === EmptyString ? 0 : (vehicleBrand.value === EmptyString || vehicleBrand.value === null ? 0 : parseInt(vehicleBrand.value)),
                employeeName: EmptyString,
                vehicleModel,
                status,
                transactionStatus,
                pageSize: pageSize === EmptyString ? 10000000 : pageSize,
                pageIndex: i
            }
        }).then((response) => {
            if (checkResponse(response)) {
                res = response
            }
        })
        return res
    }
    async function fGetLocationList(){
        await apiGetLocation({
            data: {
                userId: localStorage.getItem('Id')
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let tempArray = []
                tempArray.push({label: "All", value: ""})

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].locationName, value: String(response.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocation(tempArray[0].value)
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetTransactionList(i).then((res) => {
            if (res !== null && typeof(res) !== "undefined"){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }

    useEffect(() => {
        setLoading({isOpen: true})

        if (firstLoad){
            fGetLocationList().then(() => {
                fBindGrid(0).then(() => {
                    setFirstLoad(false)
                    setLoading({isOpen: false})
                })
            })
        } else {
            fBindGrid(0).then(() => {
                setFirstLoad(false)
                setLoading({isOpen: false})
            })
        }

        
    },[dateFrom, dateTo, location, transactionType, status, pageSize])

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Sales</span>
            </div>
            <hr />

            {/* FILTER */}
            <div className="flex flex-col sm:flex-row justify-between gap-8 sm:mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 sm:flex-wrap w-full">
                    <div className="flex gap-4 flex-wrap justify-between">
                        <div className="flex flex-1 flex-col gap-1 w-auto sm:w-[240px]">
                            <span className="text-sm sm:text-base">Dari Tanggal</span>
                            <DatePicker value={dateFrom} onChange={dateFromChange} className="rounded h-10 bg-white text-sm sm:text-base" />
                        </div>
                        <div className="flex flex-1 flex-col gap-1 w-auto sm:w-[240px]">
                            <span className="text-sm sm:text-base">Sampai Tanggal</span>
                            <DatePicker value={dateTo} onChange={dateToChange} className="w-full rounded h-10 bg-white text-sm sm:text-base" />
                        </div>
                    </div>
                   
                   <FilterCard title='Lokasi'>
                        <Dropdown options={locationOptions} value={location} onChange={(e) => setLocation(e.value)} placeholder={"All"} />
                   </FilterCard>
                   <FilterCard title='Tipe Transaksi'>
                        <Dropdown options={DropdownTransactionType} value={transactionType} onChange={transactionTypeChange} placeholder={"Select TransactionType"} />
                   </FilterCard>
                   <FilterCard title='Status'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                   </FilterCard>
                </div>                
            </div>

            {/* SUMMARY MOBILE VIEW */}
            <div>
                <div className={`sm:hidden  px-3 bg-slate-100 flex justify-between items-center
                        ${isSummaryOpen ? 'border-t border-x rounded-t-xl pt-3 pb-1'  : 'py-3 border rounded-xl'}
                    `}
                    // onClick={() => { setIsSummaryOpen(!isSummaryOpen) }}
                >
                    <div className="flex flex-col">
                        <span className="text-xs">Total Amount</span>
                        <span className="font-semibold">{"IDR " + money(String(Math.floor(transactionList?.data?.totalAmount)))}</span>
                    </div>
                    <div className="flex gap-2">
                        <div className="bg-black text-white px-3 py-1 rounded-full flex items-center">
                            <span className="text-xs">{transactionList?.data?.totalData} trx</span>
                        </div>
                    </div>
                </div>
                {/* {isSummaryOpen && 
                    <div className={`${localStorage.getItem('IsAdmin') === '1' ? '' : 'hidden'}`}>
                        <div className="border-x py-1 px-3 bg-slate-100 flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="text-xs">Total Netto</span>
                                <span className="font-semibold">{"IDR " + money(String(Math.floor(transactionList?.data?.totalNetto)))}</span>
                            </div>
                        </div>
                        <div className="border-x border-b rounded-b-xl pt-1 pb-3 px-3 bg-slate-100 flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="text-xs">Profit</span>
                                <span className="font-semibold">{"IDR " + money(String(Math.floor(transactionList?.data?.totalProfit)))}</span>
                            </div>
                        </div>
                    </div>
                } */}
            </div>

            {/* Show Button and Print Button */}
            <div className="flex w-full justify-between mt-4 text-sm sm:text-base">
                <div className="flex items-center gap-4">
                    <span>Show </span>
                    <Dropdown className="w-20" options={DropdownPageSizeOptions} value={pageSize} onChange={pageSizeChange} placeholder={"All"} />
                </div>
                <button className="button gap-2 hidden" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
                <div>
                    <div className="flex justify-end sm:justify-start items-end h-full gap-4">
                        <PrintButton onClick={printBtnClick} />
                    </div>
                </div>
            </div>
           
            <div className="mt-5 sm:overflow-hidden sm:rounded-3xl sm:border sm:shadow-sm">
                {/* MOBILE VIEW */}
                <div className="sm:hidden text-sm">
                    { transactionList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="flex flex-col py-2 border-b" 
                                onClick={() => { transactionDataClick(data.transactionId, data.locationId) }}
                                key={i}
                            >
                                <div className="flex justify-between ">
                                    <span className="font-semibold">{ data.vehicleBrand + " " + data.vehicleModel + " " + data.vehicleColor }</span>
                                    <span className="text-sm">{ moment(data.transactionDate).format("DD MMM yyyy") }</span>
                                </div>
                                <div className="flex justify-between ">
                                    <span className="">{ data.licensePlateNumber }</span>
                                    <span className="text-sm">{ GetTransactionStatus(data.transactionStatus) }</span>
                                </div>
                                <div className="flex justify-between ">
                                    <span>{ data.locationName }</span>
                                    <span>{  }</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
                
                {/* WEB VIEW */}
                <table className="w-full bg-white hidden sm:table">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Kode</th>
                            <th className="font-semibold text-left px-2">Tgl. Pembukuan</th>
                            <th className="font-semibold text-left px-2">Tgl. Transaksi</th>
                            <th className="font-semibold text-left px-2">Lokasi</th>
                            <th className="font-semibold text-left px-2">Detail Kendaraan</th>
                            <th className="font-semibold text-left px-2">Plat Nomor</th>
                            <th className="font-semibold text-left px-2">Tipe</th>
                            <th className="font-semibold text-left px-2">Status Transaksi</th>
                            <th className="font-semibold text-left px-2">Tarrif</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                        </tr>
                    </thead>
                    <tbody className="">
                        { transactionList?.data?.listData?.length < 1 && (
                            <tr className="border-t">
                                <td colSpan={9} className="text-center py-3">
                                    <span>No Data Available</span>
                                </td>
                            </tr>
                        )}
                        { transactionList?.data?.listData?.map((data, i) => {
                            return(
                                <tr 
                                    className="my-2 row h-10 border-t hover:bg-slate-200 cursor-pointer" 
                                    key={ i }
                                    onClick={() => { transactionDataClick(data.transactionId, data.locationId) }}
                                >
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="text-center">PR-{ data.transactionId }</td>
                                    <td className="px-2">
                                        <span>{ moment(data.transactionalDate).format("DD MMM yyyy") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ moment(data.transactionDate).format("DD MMM yyyy") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.locationName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.vehicleBrand + " " + data.vehicleModel + " " + data.vehicleColor }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.licensePlateNumber }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ GetTransactionType(data.transactionType) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ GetTransactionStatus(data.transactionStatus) }</span>
                                    </td>
                                    <td className="px-2 text-left">
                                        <span>Rp { money(data.calculatedTarrif) }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                    <tfoot>
                        <tr className="h-10 border-t">
                            <td colSpan={8} className="text-right px-2 font-semibold">
                                Total
                            </td>
                            <td className="text-left px-2 font-semibold" colSpan={2}>
                                Rp { money(String(transactionList?.data?.totalAmount)) }
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        
            {salesFormModal.isOpen && ( 
                <SalesFormModal 
                    onClose={salesFormModalClose} 
                    data={salesFormModal?.data} 
                    transactionId={salesFormModal?.transactionId} 
                    locationId={salesFormModal?.locationId}
                    formType={salesFormModal?.formType} 
                /> 
            )}
        </div>
    )
}

const FilterCard = ({title, children}) => {
    return (
        <div className="flex flex-col gap-1 w-full sm:w-[280px] text-sm sm:text-base">
            <span>{title}</span>
            {children}
        </div>
    )
}